import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/site';
type CTAButtonProps = {
  label: string;
  sublabel?: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  sublabel,
  id,
  className = ''
}: CTAButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`animate-cta-pulse group mx-auto flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl border-b-4 border-go-deep bg-go px-5 py-4 text-center text-white shadow-[0_12px_30px_-10px_rgba(22,163,74,0.7)] transition-[transform,background-color] duration-150 ease-out hover:bg-go-dark active:translate-y-0.5 sm:py-5 ${className}`} data-id="element-29" data-mp="2fz232s1dx6y5">
      <span className="flex flex-col" data-id="element-30" data-mp="2ypt67bus4143">
        <span className="font-display text-[17px] font-extrabold uppercase leading-tight tracking-tight sm:text-xl" data-id="element-31" data-mp="2yquu4gww8i38">{label}</span>
        {sublabel && <span className="mt-1 text-xs font-medium text-white/85 sm:text-sm" data-id="element-32" data-mp="38oir7dhz21ok">{sublabel}</span>}
      </span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-33" data-mp="199elkjbamkiu" />
    </a>;
}